import { Dispatch } from 'redux';
import store from '~/data/store';
import { listRequest } from '~/data/store/reducer/diagnosisReport/actions/list';

import { iActionList } from '~/domain/interfaces/redux/diagnosisReport/list';

import { ListDiagnosisReport } from '~/domain/usecases/diagnosisReport/redux';

export class ReduxListDiagnosisReport implements ListDiagnosisReport {
  private send: Dispatch;

  constructor() {
    this.send = store.dispatch;
  }

  list = (params: ListDiagnosisReport.Params): iActionList =>
    this.send(listRequest(params));
}
